<template>
  <div class="dark min-h-screen">
    <div v-if="!isAuthReady" class="flex items-center justify-center min-h-screen bg-gray-900">
      <div class="text-white text-lg">Ładowanie...</div>
    </div>
    <template v-else>
      <component v-if="layout" :is="layout">
        <router-view/>
      </component>
      <router-view v-else/>
    </template>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '@/firebase/config';
import DefaultLayout from './layouts/DefaultLayout.vue';
import PreviewLayout from './layouts/PreviewLayout.vue';

const route = useRoute();
const isAuthReady = ref(false);
const currentUser = ref(null);

const layout = computed(() => {
  // Jeśli użytkownik nie jest zalogowany, nie pokazuj żadnego layoutu
  if (!currentUser.value) {
    return null;
  }
  // Użyj lekkiego layoutu dla czystych podglądów (bez UI panelu)
  if (route.name === 'preview' || route.name === 'og-preview') {
    return PreviewLayout;
  }
  return DefaultLayout;
});

onMounted(() => {
  // Nasłuchuj zmian stanu autoryzacji
  onAuthStateChanged(auth, (user) => {
    currentUser.value = user;
    isAuthReady.value = true;
  });
});
</script>





<!-- <template>
  <nav class="bg-gray-800">
    <router-link to="/">Dashboard</router-link> 
  </nav>
  <router-view/>
</template>
 -->
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  background-color: #1f2937;
}
/* 
nav {
  padding: 30px;
  text-align: left;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
